module.exports = __webpack_public_path__ + "img/red.74711c9e.gif";